import { Level } from '@nsalaun/ng-logger';

export const environment = {
  appVersion: require('../../package.json').version,
  production: true,
  loggingLevel: Level.OFF,
  enableServiceWorker: true,
  firebaseConfig: {
    apiKey: "AIzaSyD5XLPCVkIF-RjWx3xHDH1lHQDCkk4Ycio",
    authDomain: "ommi-fb9be.firebaseapp.com",
    databaseURL: "https://ommi-fb9be.firebaseio.com",
    projectId: "ommi-fb9be",
    storageBucket: "gs://ommi-fb9be.appspot.com",
    appId: "1:81814573771:web:51709ebf5a4dccd35f814e"
  },
  region: "europe-west1",
  cancelSessionFunctionUrl: "https://europe-west1-ommi-fb9be.cloudfunctions.net/cancelSession",
  pageTitle: {
    default: "Ommi",
    adminPanel: "Ommi",
    agentPanel: "Ommi",
    clientViews: "Ommi"
  },
  // features: {
  // byOmmi: true,
  // videoIdentifications: false,
  // remoteDocumentSigning: false,
  // queueAdditionalInfoForAgent: false
  // },
  // domain: "http://lg.ommi.io",
  // supportEmail: "rafal.zaborowski@lge.com",
  // nativeMobileApp: false,
  multitenancy: {
    singleTenant: true,
    singleTenantId: 'aNVk-tjskl',
  },
  sentryErrorTracking: {
    enabled: false,
    environmentName: 'prod-lg'
  },
  widgetDomain: 'https://lg-widget.ommi.io',
  signup: {
    enabled: false,
    reCaptchaSiteKey: '6LcXtRQgAAAAALGSRlYyfa0FPG1n3RSApIUfH8K-' // reCaptcha: Ommi(PROD)
  },
  twoFactorAuth: {
    totpEnabled: false
  },
  appCheckReCaptchaEnterpriseKey: "6Le3I_ErAAAAAJeRwGmrFV5g-IH3akEyoVDQoZ5b"
};